import { Button, Flex } from 'antd';
import GraphForm from './graph-form';
import { toastConfig } from 'config';
import { Grid } from '@mui/material';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import MainCard from 'components/MainCard';
import { useTheme } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import comptroller from 'assets/images/comptroller_white.svg';
import ComptrollerConfirmModal from '../ComptrollerConfirmModal';
import DetailPageHeader from 'components/header/DetailPageHeader';
import { useAddGraphDefinationMutation, useGetGraphDefinationByIdMutation } from 'store/features/comptroller/comptrollerApi';
import FormSubmitButton from 'components/button/FormSubmitButton';

function EditGraph() {
	const navigate = useNavigate();
	const state = useLocation();
	const theme = useTheme();

	// const [activate, setActivate] = useState(true);
	const activate = true;
	// console.log(setActivate);

	const [submitForm, setSubmitForm] = useState(false);

	const [showModal, setShowModal] = useState(false);

	const [modalInfo, setModalInfo] = useState(null);

	const [submitData, setSubmitData] = useState(null);

	const companyCode = useSelector((state) => state?.profile?.profileData?.creatorOrganizationId);

	const [GetGraphDefinationById, { data: graphDefinationById, isLoading: isLoadingById }] = useGetGraphDefinationByIdMutation();
	const [AddGraphDefination, { data: graphDefinationData, isLoading }] = useAddGraphDefinationMutation();
	const [formData, setFormData] = useState(null);
	useEffect(() => {
		if (state?.state?.id) {
			GetGraphDefinationById({ id: state?.state?.id });
		}
	}, [state]);

	useEffect(() => {
		if (graphDefinationById) {
			if (graphDefinationById?.code === '200') {
				setFormData(graphDefinationById);
			} else {
				toast.error('Failed to fetch Graph Defination', toastConfig);
			}
		} //eslint-disable-next-line
	}, [graphDefinationById]);

	const handleModalSubmit = (data) => {
		setSubmitData(data);
		setShowModal(true);

		setModalInfo({
			head: 'Module',
			action: 'submit',
		});
	};

	useEffect(() => {
		if (submitForm && submitData && companyCode) {
			submitHandle(submitData);
		} //eslint-disable-next-line
	}, [submitForm]);

	const submitHandle = (formData) => {
		const payload = {
			id: state?.state?.id,
			companyCode: companyCode,
			graphName: formData.graphName,
			graphDescription: formData.graphDescription,
			graphType: formData.graphType,
			graphQuery: formData.graphQuery,
		};
		AddGraphDefination(payload);
	};

	useEffect(() => {
		if (graphDefinationData) {
			if (graphDefinationData?.code === '200') {
				toast.success('Graph Defination Added Successfully', toastConfig);
				navigate(-1);
			} else {
				toast.error('Failed to add Graph Defination', toastConfig);
			}
		} //eslint-disable-next-line
	}, [graphDefinationData]);

	const childernOne = (
		<GraphForm handleModalSubmit={handleModalSubmit} formData={formData} isLoading={isLoadingById || isLoading}>
			<FormSubmitButton activate={isLoadingById || isLoading} detail={true} />

			{/* <Col xs={24} sm={24} md={24} xl={24}> */}
			{/* <Flex justify="flex-end" align="flex-end">
				<Button
					style={{ backgroundColor: activate ? '' : theme.palette.lynTheme.submit }}
					type="primary"
					htmlType="submit"
					disabled={isLoadingById || isLoading}
				>
					Submit
				</Button>
			</Flex> */}
			{/* </Col> */}
		</GraphForm>
	);

	return (
		<Grid container rowSpacing={4.5} columnSpacing={2.75}>
			<Grid item xs={24} lg={24}>
				<DetailPageHeader title="Edit Graph Defination" />

				<MainCard>{childernOne}</MainCard>

				{showModal && (
					<ComptrollerConfirmModal showModal={showModal} setShowModal={setShowModal} setSubmitForm={setSubmitForm} modalData={modalInfo} />
				)}
			</Grid>
		</Grid>
	);
}

export default EditGraph;
